export type WorkspaceRole = 'owner' | 'editor' | 'viewer'

const ROLE_LABELS: Record<WorkspaceRole, string> = {
  owner: 'Owner',
  editor: 'Editor',
  viewer: 'Viewer',
}

const ROLE_DESCRIPTIONS: Record<WorkspaceRole, string> = {
  owner: 'Can update workspace settings, manage members, and access all projects.',
  editor: 'Can work in projects and collaborate with other members.',
  viewer: 'Can view workspace content without making changes.',
}

export function formatWorkspaceRole(role?: string | null): string {
  if (!role) {
    return 'Member'
  }

  return ROLE_LABELS[role as WorkspaceRole] ?? role.charAt(0).toUpperCase() + role.slice(1)
}

export function describeWorkspaceRole(role: WorkspaceRole): string {
  return ROLE_DESCRIPTIONS[role]
}
